
import React, { Component } from 'react';
import startsWith from 'lodash/startsWith';

import { ContainerWithToolbars } from '../../core';

import ButtonCommandMscModes from './ButtonCommandMscModes';
import ButtonCommandMscTools from './ButtonCommandMscTools';

import MultiSceneBase from './MultiSceneBase';

export default class MultiScene extends Component {

    componentDidMount() {
        this.props.multiSceneActions.selectMode(
            this.getMode()
        );
    }

    componentDidUpdate(prevProps) {
        if (this.props.mode !== prevProps.mode) {
            this._multiSceneBaseComponent.selectMode(this.props.mode);
        }
    }

    getMode() {
        return this.props.mode || this.props.initialMode || 'points';
    }

    getModeParams = (modeId) => {
        return this._multiSceneBaseComponent.getModeParams(modeId);
    }

    handleCameraChange = (params) => {
        if (this.props.onCameraChange) {
            this.props.onCameraChange(params);
        }
    }

    handleMscSelectMode = (modeId) => {
        this.props.multiSceneActions.selectMode(modeId);
    }

    handleMscSelectTool = (toolId, tool) => {
        this._multiSceneBaseComponent.selectTool(toolId);

        let isToolMeasure = (
            tool &&
            startsWith(tool.toolId, 'PointCloudMeasure')
        );

        if (isToolMeasure) {
            this.props.measurementActions.setMeasureTool(tool);
        } else {
            this.props.measurementActions.setMeasureTool(null);
        }
    }

    render() {
        const tools = this.props.disableMeasure ? ['SelectObjectControl'] : null;

        const multiSceneToolButtons = [
            ...(this.props.buttonsBefore || []),
            <ButtonCommandMscTools
                tools={tools}
                onSelectTool={this.handleMscSelectTool}
                additionalButtonTools={{
                    measure: [
                    ]
                }}
            />,
            ...(this.props.buttonsAfter || [])
        ];

        const multiSceneModeButtons = [
            <ButtonCommandMscModes
                modes={this.props.modes}
                value={this.props.mode}
                onSelectMode={this.handleMscSelectMode}
            />
        ];

        let {mode, ...props} = this.props;

        return (
            <ContainerWithToolbars
                toolbars={[
                    {position: 'right', direction: '', buttons: multiSceneToolButtons},
                    {position: 'top', direction: '', buttons: multiSceneModeButtons}
                ]}
            >
                <MultiSceneBase
                    ref={element => this._multiSceneBaseComponent = element}
                    mode={this.getMode()}
                    onCameraChange={this.handleCameraChange}
                    {...props}
                />
            </ContainerWithToolbars>
        );
    }

    selectMode = (modeId) => {
        this._multiSceneBaseComponent.selectMode(modeId);
    }

    showPositionOnTrajectory(trjName, photoName, x, y, z, yaw, pitch, options) {
        this._multiSceneBaseComponent.showPositionOnTrajectory(
            trjName, photoName, x, y, z, yaw, pitch, options
        );
    }

    updateSize(w, h) {
        this._multiSceneBaseComponent.updateSize(w, h);
    }
}
